import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { Input, Select, Button, Check } from '../input';
import { Error } from '../error';
import { CardDisplay } from './CardDisplay';
import { useGlobal } from '../../state';

export const AutoReload = () => {
  const { user, refreshUser, fox } = useGlobal();
  const last4 = user?.paymentMethodLast4;

  const [loading, setLoading] = useState();
  const [error, setError] = useState();

  const [enabled, setEnabled] = useState(user?.autoReloadEnabled ?? false);
  const [target, setTarget] = useState(user?.autoReloadTarget ?? '');
  const [floor, setFloor] = useState(user?.autoReloadFloor ?? '');

  const choices = [
    [1, '$1'],
    [5, '$5'],
    [10, '$10'],
    [25, '$25'],
    [50, '$50'],
    [100, '$100'],
    [250, '$250'],
    [500, '$500'],
  ];

  useEffect(() => {
    if (!user) {
      return;
    }

    setEnabled(user.autoReloadEnabled);
    setTarget(user.autoReloadTarget);
    setFloor(user.autoReloadFloor);
  }, [user]);

  useEffect(() => {
    if (target <= floor) {
      const newTarget = choices.filter(([val]) => val > floor)[0][0];
      setTarget(newTarget);
    }
  }, [floor]);

  const handleSubmit = async () => {
    const numTarget = parseInt(target, 10);
    if (!numTarget || isNaN(numTarget)) {
      alert('Please enter a valid amount to reload up to.');
      return;
    }

    const numFloor = parseInt(floor, 10);
    if (!numFloor || isNaN(numFloor)) {
      alert('Please enter a valid number of credits.');
      return;
    }

    setError(null);
    setLoading(true);
    try {
      console.log('call auto reload');

      const data = await fox.call('POST', '/api/credits/auto-reload', {
        autoReloadEnabled: enabled,
        autoReloadFloor: numFloor,
        autoReloadTarget: numTarget,
      });
      console.log('data, toast', data);
      toast.info('Saved auto reload settings');
    } catch (e) {
      setError(String(e.error || e));
    } finally {
      refreshUser();
      setLoading(false);
    }
  };

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Check useSwitch value={enabled} onChange={setEnabled}>
          Enable auto reload
        </Check>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, opacity: enabled ? 1.0 : 0.5 }}>
        <div>
          <div style={{ marginBottom: 6 }}>When credit balance reaches:</div>
          <div>
            <Select choices={choices} value={floor} onChange={setFloor} style={{ width: '100%' }} />
          </div>
        </div>

        <div>
          <div style={{ marginBottom: 6 }}>Bring credit balance back up to:</div>
          <div>
            <Select
              choices={choices.filter(([val]) => val > floor)}
              value={target}
              onChange={setTarget}
              style={{ width: '100%' }}
            />
          </div>
        </div>

        {/*
        <div>
          <div style={{ marginBottom: 6 }}>Charged to</div>
          <div>
            <CardDisplay inline />
          </div>
        </div>
        */}
      </div>

      <Button loading={loading} onClick={handleSubmit}>
        Save
      </Button>
      <Error message={error} />
    </div>
  );
};
